const imageSrc = '/assets/images/main-bg.svg';
const greetingBG = {
    height: {
        mobile: '180px',
        desktop: '232px',
    },
    mb: {
        mobile: '-72px',
        desktop: '-120px',
    },
    flexGrow: 1,
    width: '100%',
    backgroundImage: `url(${imageSrc})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    pointerEvents: 'none',
};
const icon = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '38px',
    width: '38px',
    boxShadow: 2,
    borderRadius: '50%',
};
export default {
    greetingBG,
    icon,
};
